import React, { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { TableRowProps } from './types';
import { useTableContext } from './blocs/table-context.web';
import { useTheme } from '@/contexts/theme-context';

export const TableRow: React.FC<TableRowProps<React.CSSProperties>> = ({
  'aria-selected': ariaSelected,
  children,
  index,
  style,
}) => {
  const theme = useTheme();
  const { virtualizer } = useTableContext();
  const measureElement =
    index === undefined ? undefined : virtualizer.measureElement;
  const rowStyle: React.CSSProperties = useMemo(
    () => ({
      borderRadius: theme.sk.radii.radiusMedium,
      display: 'flex',
      flexDirection: 'row',
      // Use overflow: 'visible' to allow sticky columns to work
      // Sticky positioning requires the parent to not have overflow: hidden
      overflow: 'visible',
    }),
    [theme],
  );

  const borderStyle: React.CSSProperties = useMemo(
    () => ({
      backgroundColor: theme.sk.color.divider.default,
      height: '1px',
    }),
    [theme],
  );

  return (
    // data-index is required for TanStack Virtual to measure elements
    <div data-index={index} ref={measureElement}>
      <div
        aria-selected={ariaSelected}
        role="row"
        style={StyleSheet.flatten([rowStyle, style])}
      >
        {children}
      </div>
      <div style={borderStyle} />
    </div>
  );
};
